import { SessionRole } from "../services/session.service";

export const ROLES: Record<string, SessionRole> = <const>{
  USER: { title: "Gebruiker", code: "USER" },
  MANAGER: { title: "Manager", code: "MANAGER" },
};
